import React, { Component } from "react";
import CytoscapeComponent from "react-cytoscapejs";
import generateGenesAndEdges from "./../../utils/generateGenesAndEdges";
import { Button } from "reactstrap";
import PDFDocument from "../PDFDocument/pdfDocument";
import { pdf } from "@react-pdf/renderer";
import Loader from "react-loaders";
import axiosInstance from "../configuration/Request";



class CytoscapeGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      initialElements: generateGenesAndEdges(
        this.props.nodeDetails,
        this.props.dataType
      ),
      elements: generateGenesAndEdges(
        this.props.nodeDetails,
        this.props.dataType
      ),
      layout: { name: "random", fit: true, padding: 0 },
      templateData: {
        networkresult: "",
        dataSourceCategorization: "",
      },
      imageCaptured: false
    };
    this.handleGeneClick = this.handleGeneClick.bind(this);
    this.handleLayoutComplete = this.handleLayoutComplete.bind(this);
    this.resetGraph = this.resetGraph.bind(this);
    this.cyRef = React.createRef();
    if (props.forwardedRef) {
      props.forwardedRef.current = {
        generateImage: this.generateImage.bind(this)
      };
    }
  }

  handleGeneClick(event) {
    const clickedNode = event.target;
    const clickedNodeData = clickedNode.data();
    const connectedEdges = clickedNode.connectedEdges();
    const connectedEdgesData = connectedEdges.map((edge) => edge.data());
    if (this.props.onGeneClick) {
      this.props.onGeneClick({
        clickedNodeData,
        connectedEdgesData,
      });
    }
  }


  handleLayoutComplete(cy) {
    const newElements = cy.nodes().map((node) => {
      const { x, y } = node.position();
      return {
        data: node.data(),
        position: { x, y },
      };
    });

    this.setState({
      elements: newElements,
      layout: { name: "preset" },
    });
  }



  handleZoomIn = () => {
    const cy = this.cyRef.current;
    const currentZoom = cy.zoom();
    cy.zoom({
      level: currentZoom * 1.2,
      renderedPosition: { x: cy.width() / 2, y: cy.height() / 2 },
    });
  };

  handleZoomOut = () => {
    const cy = this.cyRef.current;
    const currentZoom = cy.zoom();
    cy.zoom({
      level: currentZoom * 0.8,
      renderedPosition: { x: cy.width() / 2, y: cy.height() / 2 },
    });
  };

  resetGraph() {
    if (this.props.onResetClick) {
      this.props.onResetClick();
    }
  }
  downloadPDF = async () => {
    this.setState({ loader: true });
    const networkInformation = this.props.networkInformation;
    const risk_level =
      networkInformation.risk_level === "NA" ? "All Risk Levels" : "";
    const subsampling_yes_no =
      networkInformation.subsampling_yes_no === "yes"
        ? "Subsampling without replacement was performed 100 times in this study, and the most stable gene associations were retained."
        : "";
    const threshold = networkInformation.p_value
      ? `α = ${networkInformation.p_value} `
      : `precision = ${networkInformation.precision} and scope = ${networkInformation.scope} `;
    const normal_tumor =
      networkInformation.normal_tumor === "T" ? "Tumor" : "Normal";
    const imagePara = `The ${networkInformation.source_gene_name} –  ${networkInformation.target_gene_name} gene association network was generated with the Boolean implication network algorithm based on ${networkInformation.data_source} ${networkInformation.histological_subtype} ${normal_tumor} data in ${risk_level}, the sample type was ${networkInformation.sample_type} In this study, we used ${threshold}  for threshold calculations.${subsampling_yes_no}`;
    const imageName = `${networkInformation.source_gene_name}-${networkInformation.target_gene_name} gene association network in ${networkInformation.data_source} ${networkInformation.histological_subtype} ${normal_tumor} data.`;
    const filename = networkInformation.project_name + ".xlsx";
    const fileContent = {
      imageTitle: imageName,
      imageContent: imagePara,
      file: filename,
    }

    const cy = this.cyRef.current;
    const pngData = cy.png({
      full: true,
      scale: 1.2,
      bg: "white",
    });

    axiosInstance
      .get(`${process.env.REACT_APP_BASE_URL}api/download?id=${networkInformation.id}`,)
      .then((res) => {

        this.initiateDownload(pngData, fileContent, res?.data?.downloadUrl)
      })
      .catch((err) => {
        console.error("File fetch failed:", err);
      });

  };

  initiateDownload = async (pngData, fileContent, downloadableUrl) => {
    const blob = await pdf(
      <PDFDocument
        graphImage={pngData}
        fileContent={fileContent}
        networkInformation={this.props.networkInformation}
        fileUrl={downloadableUrl}
      />
    ).toBlob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Network_Report.pdf");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    this.setState({ loader: false });
  }

  generateImage = () => {
    const cy = this.cyRef.current;
    const pngData = cy.png({
      full: true,
      scale: 1.2,
      bg: "white",
    });
    if (this.props.onImageGenerate) {
      this.props.onImageGenerate(pngData);
    }
  };

  render() {
    const stylesheet = [
      {
        selector: "node",
        style: {
          label: "data(label)",
          "text-valign": "center",
          "text-halign": "center",
          "background-color": "data(colorType)",
          shape: "data(shapeType)",
          "text-outline-color": "#ffffff",
          "text-outline-width": "2px",
          "font-weight": "bold",
          // color: "data(fontColorType)",
          "text-wrap": "wrap",
          "font-size": "8px",
          "text-max-width": "50px",

          // Add border with darker shade
          "border-width": 1,
          "border-color": (ele) => getDarkerShade(ele.data("colorType")),

          width: (ele) => {
            const label = ele.data("label") || "";
            const labelLength = label.length;
            return Math.max(30, labelLength * 7);
          },
          height: (ele) => {
            const label = ele.data("label") || "";
            const labelLength = label.length;
            return Math.max(30, labelLength * 4);
          },
          "padding": "3px",
        },
      },

      {
        selector: "node:selected",
        style: {
          "background-color": "#BDBDBD",
        },
      },
      {
        selector: "edge",
        style: {
          width: 3,
          "line-color": "#9dbaea",
          "target-arrow-color": "#9dbaea",
          "target-arrow-shape": "triangle",
          // "curve-style": "bezier", // smoother edges
          // "target-arrow-color": "#9dbaea",
          // "target-arrow-shape": "triangle",

        },
      },

    ];

    return (
      <div>
        <div className="d-flex">
          <div className="cytoscape-container">
            <CytoscapeComponent
              elements={this.state.elements}
              style={{
                width: "100%",
                height: "97%",
                backgroundColor: "white",
                padding: "4px",
                borderRadius: "6px",
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
              }}
              layout={this.state.layout}
              stylesheet={stylesheet}
              cy={(cy) => {
                this.cyRef.current = cy;
                cy.on("tap", "node", this.handleGeneClick);
                cy.one("layoutstop", () => {
                  this.handleLayoutComplete(cy);

                });
              }}
              zoomingEnabled={true}
              panningEnabled={true}
              autounselectify={false}
              boxSelectionEnabled={true}
              userPanningEnabled={true}
            />
          </div>
          <div className="zoom-buttons-container">
            <button className="zoom-button" onClick={this.handleZoomIn}>
              +
            </button>
            <button className="zoom-button" onClick={this.handleZoomOut}>
              -
            </button>
          </div>
        </div>
        <div className="view-network-button-container">
          <Button
            className="view-reset-buttons"
            color="secondary"
            onClick={this.resetGraph}
          >
            Reset Network
          </Button>
          <Button
            className="view-download-buttons w-80"
            color="primary"
            onClick={this.downloadPDF}
          >
            Download Results
          </Button>
        </div>
        {this.state.loader && (
          <div className="backdrop">
            <div className="loader">
              <Loader type="ball-pulse-rise" />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default React.forwardRef((props, ref) => (
  <CytoscapeGraph {...props} forwardedRef={ref} />
));

/**
 * Function to generate a darker shade of a given color
 */
function getDarkerShade(color) {
  let r, g, b;

  if (color.startsWith("#")) {
    const bigint = parseInt(color.slice(1), 16);
    r = (bigint >> 16) & 255;
    g = (bigint >> 8) & 255;
    b = bigint & 255;
  } else {
    return "#000";
  }
  r = Math.max(0, Math.floor(r * 0.7));
  g = Math.max(0, Math.floor(g * 0.7));
  b = Math.max(0, Math.floor(b * 0.7));

  return `rgb(${r}, ${g}, ${b})`;
}
